import './index.scss';
import { Flex, Gap } from '@phi/components/layout';
import { PropType, defineComponent, h } from 'vue';

export const FormWithLabels = defineComponent({
    props: {
        gap: {
            required: false,
            type: String as PropType<Gap>,
            default: 'normal',
        },

        width: {
            required: false,
            type: String,
            default: '50%',
        }
    },

    render() {
        return h(Flex, {
            class: 'form-with-labels',
            gap: this.gap,
            style: {
                '--width': this.width,
            }
        }, () => this.$slots.default ? this.$slots.default() : '');
    }
});
